import React from 'react';

export default function AaDomainVis(): JSX.Element {
  return (
    <>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 8.0175 21.3145)"
        fill="#8DB800"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 6.02081 9.25293)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 9.49409 14.1475)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.578881 0.815781 -0.802405 0.59678 5.69698 10.7397)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 16.8096 33.3149)"
        fill="#ACDA11"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 14.8129 21.2534)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 18.2862 26.1479)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.578881 0.815781 -0.802405 0.59678 14.4891 22.7402)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 63.9825 21.3145)"
        fill="#8DB800"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 65.9792 9.25293)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 62.5059 14.1475)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.578881 0.815781 0.802405 0.59678 66.303 10.7397)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 55.1904 33.3149)"
        fill="#ACDA11"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 57.1871 21.2534)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 53.7138 26.1479)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.578881 0.815781 0.802405 0.59678 57.5109 22.7402)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 15.8327 15.3145)"
        fill="#2C55E7"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 13.836 3.25293)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 17.3093 8.14746)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.578881 0.815781 -0.802405 0.59678 13.5122 4.73975)"
          fill="white"
        />
      </g>
      <rect
        width="7.8152"
        height="13.0002"
        rx="1.5"
        transform="matrix(1 0 -0.0131528 -0.999913 27.5343 61)"
        fill="#B2C3FF"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.000311317 1 -1 0 32.8577 50.0771)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.000311317 1 -1 0 32.8559 56.0771)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.000311317 1 -1 0 31.7324 51.0771)"
          fill="white"
        />
      </g>
      <path
        d="M28.3533 25.0005L30.812 27.5361C31.1815 27.9172 31.3843 28.4295 31.3759 28.9602L31.2957 34.0007"
        stroke="#979799"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <rect
        width="7.8152"
        height="13.0002"
        rx="1.5"
        transform="matrix(1 0 -0.0131528 -0.999913 27.5343 46.9995)"
        fill="#B2C3FF"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.000311317 1 -1 0 32.8577 36.0767)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.000311317 1 -1 0 32.8559 42.0767)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.000311317 1 -1 0 31.7324 37.0767)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 24.6248 27.3149)"
        fill="#B2C3FF"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 22.6281 15.2534)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578881 0.815781 -0.802405 0.59678 26.1014 20.1479)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.578881 0.815781 -0.802405 0.59678 22.3043 16.7402)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 56.6617 15.3145)"
        fill="#2C55E7"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 58.6584 3.25293)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 55.1851 8.14746)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.578881 0.815781 0.802405 0.59678 58.9822 4.73975)"
          fill="white"
        />
      </g>
      <rect
        width="7.8152"
        height="13.0002"
        rx="1.5"
        transform="matrix(-1 0 0.0131528 -0.999913 44.9602 61)"
        fill="#B2C3FF"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.000311317 1 1 0 39.6367 50.0771)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.000311317 1 1 0 39.6385 56.0771)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.000311317 1 1 0 40.762 51.0771)"
          fill="white"
        />
      </g>
      <path
        d="M44.1411 25.0005L41.6824 27.5361C41.313 27.9172 41.1101 28.4295 41.1185 28.9602L41.1987 34.0007"
        stroke="#979799"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <rect
        width="7.8152"
        height="13.0002"
        rx="1.5"
        transform="matrix(-1 0 0.0131528 -0.999913 44.9602 46.9995)"
        fill="#B2C3FF"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.000311317 1 1 0 39.6367 36.0767)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.000311317 1 1 0 39.6385 42.0767)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(0.000311317 1 1 0 40.762 37.0767)"
          fill="white"
        />
      </g>
      <rect
        width="7.8796"
        height="12.8934"
        rx="1.5"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 47.8696 27.3149)"
        fill="#B2C3FF"
      />
      <g>
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 49.8663 15.2534)"
            fill="white"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578881 0.815781 0.802405 0.59678 46.393 20.1479)"
            fill="white"
          />
        </g>
        <rect
          width="7.34615"
          height="0.75"
          transform="matrix(-0.578881 0.815781 0.802405 0.59678 50.1901 16.7402)"
          fill="white"
        />
      </g>
    </>
  );
}
